import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';

function _window(): Window & typeof globalThis {
  // return the global native browser window object
  return window;
}

@Injectable({
  providedIn: 'root'
})
export class WindowRef {
  // eslint-disable-next-line @typescript-eslint/ban-types
  constructor(@Inject(PLATFORM_ID) private platformId: Object) {}

  get nativewindow(): (Window & typeof globalThis) | null {
    if (isPlatformBrowser(this.platformId)) {
      return _window();
    } else {
      return null;
    }
  }

  nativeWindow(): (Window & typeof globalThis) | null {
    if (isPlatformBrowser(this.platformId)) {
      return _window();
    } else {
      return null;
    }
  }

  getHost(): string | undefined {
    return this.nativeWindow()?.location?.host || undefined;
  }

  getProtocol(): string | undefined {
    return this.nativeWindow()?.location?.protocol || undefined;
  }

  getPort(): string | undefined {
    return this.nativeWindow()?.location?.port || undefined;
  }

  getOrigin(): string | undefined {
    return this.nativeWindow()?.location?.origin || undefined;
  }
}
